<template>
  <v-layout row wrap :class="['gear-category']" align-space-between fill-height>
    <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
      <h3 v-html="title" :class="['font-weight-light', 'title', 'pb-3']" />
      <v-divider />
    </v-flex>
    <v-flex lg3 md4 sm4 xs12 :class="['pa-2', item.enlarge ? '' : 'pointer-events-none']" v-for="(item, index) in gear" :key="index">
      <v-card @click.capture="gtagEvent('view', 'gear', title, item.caption)" ripple :to="`/gear/${item.slug}`" :title="$lang.viewGear(item.caption)" :class="['full-height']">
        <v-img :src="makeThumbnailUrl(item.slug, item.enlarge)" aspect-ratio="1.7778" :class="['bw-image-filter', 'gear-category-image']" :lazy-src="$config.replacementImage" />
        <v-card-title :class="['pa-1', 'font-weight-light']" primary-title>
          <div v-html="item.caption" :class="['subheading', 'text-xs-center']" />
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'GearCategory',
  mixins: [
    methods
  ],
  props: {
    title: {
      type: String,
      required: true
    },
    gear: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },
  methods: {
    makeThumbnailUrl (slug, enlarge) {
      const images = 'https://wemakesites.net/images/music/'
      if (enlarge) {
        return `${images}${slug}/image-01.jpg`
      } else {
        return `${images}guitar-thumbs/${slug}.jpg`
      }
    }
  }
}
</script>
<style>
.gear-category .subheading
{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/gear-category.vue